export default {
  //apiUrl: "https://localhost:44372/api",
  //apiUrl: "https://uatapi.paratic.com.tr/api",
  apiUrl: "https://api.tahsilite.com/api",
  isFinekraLogoApiUrl: "https://logo-api.finekra.com/api",
  apiContentUrl : "https://api.tahsilite.com/Content/CardLogo",
  //apiUrl: "https://test-api.finekra.com/api",
  headers: {
    headers: { Authorization: "Bearer " + localStorage.getItem("token") },
  },
  //demoUrl: "https://localhost:44351/",
  demoUrl: "https://test.finekra.com/",
  //demoUrl: "https://www.finekra.com/",
  //frontEndUrl: "http://localhost:3000/",
  // frontEndUrl: "https://panel.paratic.com.tr/",
  //frontEndUrl: "https://ykb.finekra.com/",
  frontEndUrl: "https://panel.tahsilite.com/",
  //supportPanelImgUrl: "https://localhost:44391",
  supportPanelImgUrl: "https://api.tahsilite.com/api",
  renderNotifications: false,
};
